import type { Line } from '../../domain'

/**
 * Letra con los acordes encima, a partir de los anclajes (nunca de espacios de alineación).
 * Cada palabra es un bloque que no se parte, así que la línea se ajusta al ancho sin separar un
 * acorde de su sílaba.
 */
export interface Piece {
  text: string
  chord?: { id: string; symbol: string }
}

export interface Word {
  key: number
  pieces: Piece[]
}

export function splitLine(line: Pick<Line, 'text' | 'chords'>): Word[] {
  const { text, chords } = line
  const tokens = [...text.matchAll(/\S+\s*|\s+/g)].map((match) => ({
    start: match.index ?? 0,
    end: (match.index ?? 0) + match[0].length,
  }))
  if (tokens.length === 0) tokens.push({ start: 0, end: 0 })
  const words: Word[] = []
  tokens.forEach((token, tokenIndex) => {
    const isLast = tokenIndex === tokens.length - 1
    const inside = chords.filter(
      (anchor) =>
        anchor.at >= token.start && (anchor.at < token.end || (isLast && anchor.at === token.end)),
    )
    const pieces: Piece[] = []
    let cursor = token.start
    if (inside.length === 0 || inside[0]!.at > token.start) {
      const end = inside[0]?.at ?? token.end
      pieces.push({ text: text.slice(token.start, end) })
      cursor = end
    }
    inside.forEach((anchor, index) => {
      const end = inside[index + 1]?.at ?? token.end
      pieces.push({ text: text.slice(cursor, end), chord: { id: anchor.id, symbol: anchor.chord } })
      cursor = end
    })
    words.push({ key: token.start, pieces })
  })
  return words
}
